import { jsx as _jsx } from "react/jsx-runtime";
import { Cancel } from "sprout-ui-icons";
import styled from "styled-components";
import { Button } from "sprout-ui-dom/dist/Button";
import { themeGet } from "sprout-ui-theme";
const SearchClearButton = styled(Button)`
  width: 24px;
  height: 24px;

  color: ${themeGet("colors.black.60")};
`;
const SearchClear = (props)=>{
    const { onClick  } = props;
    return /*#__PURE__*/ _jsx(SearchClearButton, {
        variant: "circle",
        onClick: onClick,
        children: /*#__PURE__*/ _jsx(Cancel, {})
    });
};
export default SearchClear;
